module.exports = __webpack_public_path__ + "media/src/images/feature-02-1c2b41a45abf6f74389b827b43cf8a65.png";